import React from "react";
import { ReactComponent as CastSVG } from "assets/player/cast.svg";
import { Button } from "../Button";

const Cast = ({ onClick }) => (
  <Button onClick={onClick}>
    <CastSVG height={25} width={25} />
  </Button>
);

export default Cast;
